// i18n dictionary for ERA Group.

const en = {
  nav: {
    ecosystem: "Ecosystem",
    about: "About",
    industries: "Industries",
    whyEra: "Why ERA",
    contact: "Contact",
    cta: "Get in touch",
    langLabel: "Language",
  },
  stats: {
    clients: "Trusted Clients",
    projects: "Projects Delivered",
    units: "Business Units",
    years: "Years of Experience",
  },
  ecosystem: {
    eyebrow: "Integrated Business Ecosystem",
    titleA: "Building an",
    titleB: "Integrated Business",
    titleC: "Ecosystem.",
    subtitle:
      "ERA Group brings together specialized companies into one integrated ecosystem, helping organizations solve complex business challenges through connected expertise.",
    sectionTitle: "Explore Our Ecosystem.",
    sectionSubtitle:
      "Each business unit specializes in different capabilities while working together as one integrated ecosystem.",
    unitLabel: "Business Unit",
    visit: "Visit Website",
    comingSoon: "Coming Soon",
    primaryCta: "Explore Ecosystem",
    secondaryCta: "Contact Us",
    since: "Since 2015",
  },
  about: {
    eyebrow: "About ERA Group",
    title: "One holding.",
    titleAccent: "Many specialized capabilities.",
    body: "ERA Group is a holding company that unites specialized business units into one integrated ecosystem, enabling organizations to grow through connected expertise.",
    visionLabel: "Vision",
    vision:
      "To become Indonesia's trusted integrated business ecosystem for sustainable organizational growth.",
    missionLabel: "Mission",
    mission: {
      expertise: {
        title: "Deliver Expertise",
        desc: "Provide deep, specialized knowledge across every discipline in the group.",
      },
      innovation: {
        title: "Drive Innovation",
        desc: "Adopt modern methods and technology to help clients stay ahead.",
      },
      partnerships: {
        title: "Build Partnerships",
        desc: "Grow long-term relationships built on integrity and shared success.",
      },
      growth: {
        title: "Create Sustainable Growth",
        desc: "Design outcomes that compound value for years, not just quarters.",
      },
    },
    valuesLabel: "Core Values",
    values: {
      integrity: { title: "Integrity", desc: "We do what's right." },
      innovation: { title: "Innovation", desc: "We keep improving." },
      collaboration: { title: "Collaboration", desc: "We grow together." },
      excellence: { title: "Excellence", desc: "We deliver measurable results." },
    },
  },
  industries: {
    eyebrow: "Industries We Serve",
    title: "Delivering value across every",
    titleAccent: "sector.",
    subtitle:
      "Our combined expertise adapts to your industry — not the other way around.",
    labels: {
      manufacturing: "Manufacturing",
      construction: "Construction",
      healthcare: "Healthcare",
      food: "Food & Beverage",
      education: "Education",
      government: "Public Sector",
      energy: "Energy",
      mining: "Mining",
      automotive: "Automotive",
    },
  },
  why: {
    eyebrow: "Why ERA Group",
    title: "Trusted by Organizations.",
    titleAccent: "Chosen for Results.",
    items: {
      integrated: {
        title: "Integrated Solutions",
        desc: "One ecosystem, many disciplines. From IT and outsourcing to certification — connected as a single group.",
      },
      experts: {
        title: "Professional Experts",
        desc: "Certified practitioners with cross-industry, enterprise-scale experience.",
      },
      trusted: {
        title: "Trusted Partner",
        desc: "Chosen by leading private enterprises, public institutions, and global partners.",
      },
      coverage: {
        title: "National & Global Reach",
        desc: "From Sumatra to Papua and beyond — we operate wherever your business does.",
      },
      innovation: {
        title: "Innovation Driven",
        desc: "Continuously modernizing methods, tooling, and delivery models.",
      },
      partnership: {
        title: "Long-Term Partnership",
        desc: "We build durable relationships, not one-off transactions.",
      },
    },
  },
  contact: {
    eyebrow: "Contact",
    title: "Let's build something",
    titleAccent: "together.",
    subtitle:
      "Choose the business unit that fits your needs, or reach the ERA Group team directly. We respond within one business day.",
    visitBUTitle: "Visit Business Unit",
    reachTitle: "Reach ERA Group",
    formTitle: "Send us a message",
    name: "Name",
    email: "Email",
    company: "Company",
    phone: "Phone",
    message: "Message",
    namePh: "Your full name",
    emailPh: "you@company.com",
    companyPh: "Company name",
    phonePh: "+62 8xx-xxxx-xxxx",
    messagePh: "Tell us about your goals...",
    disclaimer:
      "By submitting this form you agree to be contacted by the ERA Group team regarding your inquiry.",
    submit: "Send Message",
    submitting: "Sending...",
    toastSuccess: "Your message was sent. Our team will be in touch.",
    toastMissing: "Please complete Name, Email, and Message.",
    toastError: "Something went wrong. Please try again.",
    whatsapp: "Chat via WhatsApp",
    whatsappTooltip: "Chat with us on WhatsApp",
  },
  footer: {
    tagline: "Integrated Business Ecosystem",
    intro:
      "A holding company that unites specialized business units into one integrated ecosystem — helping organizations grow through connected expertise.",
    columns: {
      explore: "Explore",
      units: "Business Units",
      resources: "Resources",
      contact: "Contact",
    },
    links: {
      about: "About",
      ecosystem: "Business Units",
      industries: "Industries",
      whyEra: "Why ERA",
      contact: "Contact",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      careers: "Careers",
    },
    rights: "All rights reserved.",
    made: "Designed & built in Bekasi, Indonesia.",
    social: "Follow us",
  },
};

const id = {
  nav: {
    ecosystem: "Ekosistem",
    about: "Tentang",
    industries: "Industri",
    whyEra: "Mengapa ERA",
    contact: "Kontak",
    cta: "Hubungi Kami",
    langLabel: "Bahasa",
  },
  stats: {
    clients: "Klien Terpercaya",
    projects: "Proyek Selesai",
    units: "Unit Bisnis",
    years: "Tahun Pengalaman",
  },
  ecosystem: {
    eyebrow: "Ekosistem Bisnis Terintegrasi",
    titleA: "Membangun",
    titleB: "Ekosistem Bisnis",
    titleC: "Terintegrasi.",
    subtitle:
      "ERA Group menyatukan perusahaan-perusahaan spesialis ke dalam satu ekosistem terpadu, membantu organisasi memecahkan tantangan bisnis yang kompleks melalui keahlian yang terkoneksi.",
    sectionTitle: "Jelajahi Ekosistem Kami.",
    sectionSubtitle:
      "Setiap unit bisnis memiliki spesialisasi berbeda, namun bekerja bersama sebagai satu ekosistem terintegrasi.",
    unitLabel: "Unit Bisnis",
    visit: "Kunjungi Website",
    comingSoon: "Segera Hadir",
    primaryCta: "Jelajahi Ekosistem",
    secondaryCta: "Hubungi Kami",
    since: "Sejak 2015",
  },
  about: {
    eyebrow: "Tentang ERA Group",
    title: "Satu holding.",
    titleAccent: "Banyak keahlian spesialis.",
    body: "ERA Group adalah perusahaan induk yang menyatukan unit-unit bisnis spesialis ke dalam satu ekosistem terpadu, memungkinkan organisasi tumbuh melalui keahlian yang saling terhubung.",
    visionLabel: "Visi",
    vision:
      "Menjadi ekosistem bisnis terintegrasi paling dipercaya di Indonesia untuk pertumbuhan organisasi yang berkelanjutan.",
    missionLabel: "Misi",
    mission: {
      expertise: {
        title: "Menghadirkan Keahlian",
        desc: "Menyediakan pengetahuan spesialis yang mendalam di setiap disiplin grup.",
      },
      innovation: {
        title: "Mendorong Inovasi",
        desc: "Mengadopsi metode dan teknologi modern agar klien tetap selangkah di depan.",
      },
      partnerships: {
        title: "Membangun Kemitraan",
        desc: "Mengembangkan hubungan jangka panjang berlandaskan integritas dan kesuksesan bersama.",
      },
      growth: {
        title: "Menciptakan Pertumbuhan Berkelanjutan",
        desc: "Merancang hasil yang menciptakan nilai jangka panjang, bukan sesaat.",
      },
    },
    valuesLabel: "Nilai Inti",
    values: {
      integrity: { title: "Integritas", desc: "Kami melakukan yang benar." },
      innovation: { title: "Inovasi", desc: "Kami terus berkembang." },
      collaboration: { title: "Kolaborasi", desc: "Kami tumbuh bersama." },
      excellence: {
        title: "Keunggulan",
        desc: "Kami memberikan hasil yang terukur.",
      },
    },
  },
  industries: {
    eyebrow: "Industri yang Kami Layani",
    title: "Memberikan nilai di setiap",
    titleAccent: "sektor.",
    subtitle:
      "Keahlian gabungan kami menyesuaikan dengan industri Anda — bukan sebaliknya.",
    labels: {
      manufacturing: "Manufaktur",
      construction: "Konstruksi",
      healthcare: "Kesehatan",
      food: "Makanan & Minuman",
      education: "Pendidikan",
      government: "Sektor Publik",
      energy: "Energi",
      mining: "Pertambangan",
      automotive: "Otomotif",
    },
  },
  why: {
    eyebrow: "Mengapa ERA Group",
    title: "Dipercaya Organisasi.",
    titleAccent: "Dipilih untuk Hasil.",
    items: {
      integrated: {
        title: "Solusi Terintegrasi",
        desc: "Satu ekosistem, banyak disiplin. Dari IT dan outsourcing sampai sertifikasi — terhubung dalam satu grup.",
      },
      experts: {
        title: "Ahli Profesional",
        desc: "Praktisi bersertifikat dengan pengalaman lintas industri berskala enterprise.",
      },
      trusted: {
        title: "Mitra Terpercaya",
        desc: "Dipilih oleh perusahaan swasta terkemuka, instansi publik, dan mitra global.",
      },
      coverage: {
        title: "Jangkauan Nasional & Global",
        desc: "Dari Sumatera sampai Papua — kami hadir di mana pun bisnis Anda beroperasi.",
      },
      innovation: {
        title: "Berorientasi Inovasi",
        desc: "Terus memodernisasi metode, tools, dan model pelayanan.",
      },
      partnership: {
        title: "Kemitraan Jangka Panjang",
        desc: "Kami membangun hubungan berkelanjutan, bukan sekadar transaksi.",
      },
    },
  },
  contact: {
    eyebrow: "Kontak",
    title: "Mari bangun sesuatu",
    titleAccent: "bersama.",
    subtitle:
      "Pilih unit bisnis yang sesuai kebutuhan Anda, atau hubungi tim ERA Group langsung. Kami merespons dalam 1 hari kerja.",
    visitBUTitle: "Kunjungi Unit Bisnis",
    reachTitle: "Hubungi ERA Group",
    formTitle: "Kirim pesan kepada kami",
    name: "Nama",
    email: "Email",
    company: "Perusahaan",
    phone: "Telepon",
    message: "Pesan",
    namePh: "Nama lengkap Anda",
    emailPh: "anda@perusahaan.com",
    companyPh: "Nama perusahaan",
    phonePh: "+62 8xx-xxxx-xxxx",
    messagePh: "Ceritakan tujuan Anda...",
    disclaimer:
      "Dengan mengirim formulir ini, Anda menyetujui tim ERA Group untuk menghubungi Anda terkait pertanyaan Anda.",
    submit: "Kirim Pesan",
    submitting: "Mengirim...",
    toastSuccess: "Pesan Anda terkirim. Tim kami akan segera menghubungi.",
    toastMissing: "Mohon lengkapi Nama, Email, dan Pesan.",
    toastError: "Terjadi kesalahan. Coba lagi.",
    whatsapp: "Chat via WhatsApp",
    whatsappTooltip: "Chat WhatsApp dengan kami",
  },
  footer: {
    tagline: "Ekosistem Bisnis Terintegrasi",
    intro:
      "Perusahaan induk yang menyatukan unit-unit bisnis spesialis ke dalam satu ekosistem terpadu — membantu organisasi tumbuh melalui keahlian yang terkoneksi.",
    columns: {
      explore: "Eksplorasi",
      units: "Unit Bisnis",
      resources: "Sumber Daya",
      contact: "Kontak",
    },
    links: {
      about: "Tentang",
      ecosystem: "Unit Bisnis",
      industries: "Industri",
      whyEra: "Mengapa ERA",
      contact: "Kontak",
      privacy: "Kebijakan Privasi",
      terms: "Syarat & Ketentuan",
      careers: "Karier",
    },
    rights: "Hak cipta dilindungi.",
    made: "Dirancang & dibangun di Bekasi, Indonesia.",
    social: "Ikuti kami",
  },
};

export const DICTIONARIES = { en, id };
export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "id", label: "ID" },
];
